import styled from 'styled-components'
import { BLACK, DARK_VIOLET, GRAYSCALE_400, NEUTRAL_100, LIGHT_GRAY_2 } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const Container = styled.div`
  border: 1px solid ${NEUTRAL_100};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${NEUTRAL_100};
`

export const ProviderSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin: 12px;
`

export const ProviderIconWrapper = styled.div`
  background-color: ${LIGHT_GRAY_2};
  border-radius: 100%;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
`

export const ProviderIcon = styled.img`
  max-height: 40px;
  max-width: 40px;
`

export const ProviderName = styled.span`
  font-family: ${INTER.bold};
  font-size: 13px;
  color: ${BLACK};
`

export const AccountSection = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px 12px 12px 12px;
  gap: 12px;
`

export const FieldTitle = styled.span`
  font-family: ${INTER.semiBold};
  font-size: 14px;
  color: ${DARK_VIOLET};
`

export const AccountText = styled.span`
  font-family: ${INTER.medium};
  font-size: 14px;
  color: ${DARK_VIOLET};
`

export const AmountSection = styled.div`
  margin: 12px 12px 20px 12px;
  display: flex;
  gap: 12px;
  flex-direction: column;
`

export const FieldValueRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const FieldLabel = styled.span`
  font-family: ${INTER.regular};
  font-size: 14px;
  color: ${GRAYSCALE_400};
`

export const FieldValue = styled.span`
  font-family: ${INTER.regular};
  font-size: 14px;
  color: ${DARK_VIOLET};
`
